angular.module('bmsApp.merrymaids.job')
	.controller('MMSaveCleanModalCtrl', function ($scope,
												  $q,
												  $modalInstance,
												  $ngBootbox,
												  notify,
												  ConfigService,
												  TaxHelperSvc,
												  MMJobSvc,
												  MMJobPartSvc,
												  jobId,
												  dateOrJobPartEvent) {

		function cancel() {
			$modalInstance.dismiss('cancel');
		}

		function init() {
			$scope.config = angular.copy(ConfigService.config);
			angular.extend($scope.config.uiTimepickerOptions, {
				appendTo: '.modal-content'
			});

			if (moment.isMoment(dateOrJobPartEvent)) {
				self.jobPart = {
					job: {
						id: jobId
					},
					job_date: dateOrJobPartEvent,
					active: true,
					closed: false
				};
			}
			else {
				self.jobPart = dateOrJobPartEvent.jobPart;
				// only show pre-invoice button for cleans today and in future
				self.pastDate = moment().startOf('day').isSameOrBefore(moment(self.jobPart.job_date));
			}

			if (self.jobPart.preferred_cleaning_time) {
				self.jobPart.preferred_cleaning_time = moment(self.jobPart.preferred_cleaning_time, "HH:mm:ss");
			}

			$q.all([
				MMJobSvc.read(jobId)
					.then(function (response) {
						self.job = response.data.job;
						// if new job part set the price to the standard cleaning price of the job, not concerned about whether it's the new first clean since price syncing will
						// take care of this
						if (moment.isMoment(dateOrJobPartEvent)) {
							angular.extend(self.jobPart, {
								default_clean_net: self.job.clean_net,
								default_clean_vat: self.job.clean_vat,
								default_clean_gross: self.job.clean_gross
							});
						}
					}),
				TaxHelperSvc.getVatRate()
					.then(function (vatRate) {
						self.vatRate = vatRate;
					}),
				MMJobSvc.preferredCleaningTimeTypeOptions()
					.then(function (response) {
						self.options.preferredCleaningTimeType = response.data.options;
					})
			])
				.then(function () {
					console.info(self.vatRate);
					self.originalJobPart = angular.copy(self.jobPart);
					fillDurationFields();
					self.loading = false;
				});
		}

		function preinvoice() {
			if (checkUnchanged()) {
				$ngBootbox.confirm('Are you sure you wish to pre-invoice this clean?')
					.then(function () {
						self.preinvoicing = true;
						MMJobPartSvc.preinvoice(self.jobPart.id)
							.then(function (response) {
								self.jobPart.can_preinvoice = false;
								self.jobPart.preinvoice = response.data.invoice;
								notify({
									message: 'Successfully pre-invoiced clean.'
								});
							}, function (errors) {
								notify({
									message: errors[0],
									classes: 'error'
								});
							})
							.finally(function () {
								self.preinvoicing = false;
							});
					});
			}
		}

		function checkUnchanged() {
			return angular.isObject(self.jobPart) && angular.isObject(self.originalJobPart) && _.isEqual(self.jobPart, self.originalJobPart);
		}

		function checkChanged() {
			return !checkUnchanged();
		}

		function onCustomCleanDurationChanged() {
			angular.extend(self.jobPart, {
				job_minutes: self.job.job_minutes,
			});
			fillDurationFields();
		}

		function fillDurationFields() {
			if (angular.isNumber(self.jobPart.job_minutes)) {
				angular.extend(self.jobPart, {
					job_duration_hours: Math.floor(self.jobPart.job_minutes / 60),
					job_duration_mins: Math.round(self.jobPart.job_minutes % 60),
				});
			} else {
				angular.extend(self.jobPart, {
					job_duration_hours: 0,
					job_duration_mins: 0,
				});
			}
		}

		function onJobDurationChange() {
			self.jobPart.job_minutes = 0;
			self.jobPart.job_minutes += parseInt(self.jobPart.job_duration_hours) ? parseInt(self.jobPart.job_duration_hours) * 60 : 0;
			self.jobPart.job_minutes += parseInt(self.jobPart.job_duration_mins) ? parseInt(self.jobPart.job_duration_mins) : 0;
		}

		function onCustomCleanPriceChanged() {
			if (self.jobPart.custom_clean_price) {
				if (self.originalJobPart.custom_clean_price) {
					// reset to previous custom price
					angular.extend(self.jobPart, {
						clean_net: self.originalJobPart.clean_net,
						clean_vat: self.originalJobPart.clean_vat,
						clean_gross: self.originalJobPart.clean_gross
					});
				}
				else {
					// pre-fill custom clean price with default clean price
					angular.extend(self.jobPart, {
						clean_net: self.originalJobPart.default_clean_net,
						clean_vat: self.originalJobPart.default_clean_vat,
						clean_gross: self.originalJobPart.default_clean_gross
					});
				}
			}
		}

		function onCleanGrossUpdated() {
			var jobPart = self.jobPart;
			jobPart.clean_net = TaxHelperSvc.netFromGross(jobPart.clean_gross);
			jobPart.clean_vat = TaxHelperSvc.vatFromGross(jobPart.clean_gross);
		}

		function onCleanNetUpdated() {
			var jobPart = self.jobPart;
			jobPart.clean_vat = TaxHelperSvc.vatFromNet(jobPart.clean_net);
			jobPart.clean_gross = TaxHelperSvc.grossFromNet(jobPart.clean_net);
		}

		var self = $scope.MMSaveCleanModalCtrl = {
			methods: {
				cancel: cancel,
				init: init,
				preinvoice: preinvoice,
				checkUnchanged: checkUnchanged,
				checkChanged: checkChanged,
				onCustomCleanDurationChanged: onCustomCleanDurationChanged,
				onJobDurationChange: onJobDurationChange,
				onCustomCleanPriceChanged: onCustomCleanPriceChanged,
				onCleanGrossUpdated: onCleanGrossUpdated,
				onCleanNetUpdated: onCleanNetUpdated
			},
			options: {},
			formValidatorConfig: {
				submitHandler: function () {
					if (self.formValidatorApi.valid()) {
						self.processing = true;
						var submitCopy = angular.copy(self.jobPart);
						if (submitCopy.preferred_cleaning_time) {
							submitCopy.preferred_cleaning_time = submitCopy.preferred_cleaning_time.format('HH:mm:ss');
						}
						MMJobPartSvc.save(submitCopy)
							.then(function (response) {
								$modalInstance.close({
									success: true
								});
							}, function (errors) {
								self.errors = errors;
							})
							.finally(function () {
								self.processing = false;
							});
					}
				},
				errorPlacement: function (error) {
					error.appendTo('#form-errors');
				},
				errorContainer: '#form-errors'
			},
			formValidatorApi: {},
			event: null,
			vatRate: null,
			loading: true,
			processing: false
		};

	});
